import { STATES } from '~/constants/states';
import { intersection } from 'lodash';

export const validState = (state: string) =>
  STATES.map((stateOption) => stateOption.value).includes(state);

export const validStateArray = (sourceStates: FilterOption[], states: string[] | string) => {
  if (typeof states === 'string') return false;

  return (
    intersection(
      sourceStates.map((stateOption: FilterOption) => stateOption.value),
      states
    ).length === states.length
  );
};
